import { Button, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DeleteButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "buttonText",
})<{ buttonText: boolean }>(
  ({ theme }) => ({
    // width: "20px",
    // height:"20px",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.primary.contrastText,
    transition: theme.transitions.create(["color", "backgroundColor"]),
    // boxShadow: theme.shadows[3],
    fontSize: theme.typography.body2.fontSize,
    "&.Mui-disabled": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.text.disabled,
    },
  }),
  ({ buttonText, theme }) => ({
    ...(buttonText && {
      fontSize: theme.typography.body1.fontSize,
      backgroundColor: "transparent",
      color: theme.palette.error.main,
      textTransform: "capitalize",
      "&.Mui-disabled": {
        color: theme.palette.text.disabled,
        backgroundColor: "transparent",
      },
    }),
  })
);

export const IconDeleteButton = styled(IconButton)(({ theme }) => ({
  width: "20px",
  height: "20px",
  backgroundColor: "transparent",
  color: theme.palette.error.main,
}));
